import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { IoPencil, IoCheckmarkCircleOutline } from "react-icons/io5";
import "./component.css";

const RencanaTanamAktif = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [refreshKey, setRefreshKey] = useState(0); 

  const fetchRencanaTanam = async () => {
    const token = localStorage.getItem("token");
    setLoading(true);
    setMsg("");

    try {
      const response = await axios.get(
        "https://c-greenproject.org:8000/petanisapproved",
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );

      if (Array.isArray(response.data)) {
        let formattedData = response.data.flatMap(
          (item) => item.rencanaTanamInfo || []
        );
        setProducts(formattedData);
      } else {
        setMsg("Data tidak valid dari server.");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setMsg(
        error.response?.data?.msg || "Gagal mengambil data. Coba lagi nanti."
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRencanaTanam();
  }, [refreshKey]); // 

  useEffect(() => {
    setRefreshKey((prev) => prev + 1); 
  }, [location.pathname]);

  const handleSelesai = async (idtanam) => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Token tidak ditemukan. Silakan login ulang.");
      return;
    }

    try {
      await axios.patch(
        `https://c-greenproject.org:8000/rencanatanamselesai/${idtanam}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );

      alert("Status rencana tanam berhasil diubah menjadi 'Selesai Panen'!");
      setRefreshKey((prev) => prev + 1); 
    } catch (error) {
      console.error(
        "Error menyelesaikan rencana tanam:",
        error.response || error
      );
      alert(
        `Gagal menyelesaikan rencana tanam: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <div>
      <h2 className="title">
        <strong>Rencana Tanam Aktif</strong>
      </h2>
      <div className="detail-table-container">
        {loading && <p className="notification is-info">Memuat data...</p>}
        {msg && <p className="notification is-danger">{msg}</p>}

        {products.length > 0 ? (
          <table className="table is-striped is-fullwidth detail-table">
            <thead>
              <tr className="text-center">
                <th>No</th>
                <th>ID Tanam</th>
                <th>Status</th>
                <th>Varietas Singkong</th>
                <th>Estimasi Produksi (kg)</th>
                <th>Tanggal Rencana Tanam</th>
                <th>Tanggal Rencana Panen</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody className="text-center">
              {products.map((product, index) => (
                <React.Fragment key={product.idtanam || index}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>{product.idtanam}</td>
                    <td>{product.statusRencanaTanam}</td>
                    <td>{product.varietassingkong}</td>
                    <td>{product.estimasiproduksi}</td>
                    <td>{product.tanggalRencanaTanam}</td>
                    <td>{product.tanggalRencanaPanen}</td>
                    <td>
                      {user?.role === "petani" && (
                        <>
                          <button
                            className="btn btn-primary mt-2 button-tabel"
                            onClick={() => {
                              console.log(
                                "Navigating to:",
                                `/rencanatanam/edit/${product.idtanam}`
                              );
                              navigate(`/rencanatanam/edit/${product.idtanam}`);
                            }}
                          >
                            <IoPencil /> Edit
                          </button>
                          <button
                            className="btn btn-success mt-2 button-tabel"
                            onClick={() => handleSelesai(product.idtanam)}
                          >
                            <IoCheckmarkCircleOutline /> Selesai
                          </button>
                        </>
                      )}
                    </td>
                  </tr>

                  <tr className="detail-row">
                    <td colSpan="8">
                      <Button
                        variant="link"
                        className="btn-sm detail-button"
                        onClick={() =>
                          navigate(`/rencanatanam/${product.idtanam}`)
                        }
                      >
                        Lihat Detail Rencana Tanam
                      </Button>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        ) : (
          !loading && (
            <p className="notification is-warning">Tidak ada data tersedia.</p>
          )
        )}
      </div>
    </div>
  );
};

export default RencanaTanamAktif;
